<template>
    <div>
        <div id="pdpa-headline"
            class="theme-txt">{{header.headline}}</div>
    </div>
</template>
<script>
export default {
    name: 'pdap-header',
    props: {
        header: Object
    }
}
</script>
